import React, { Component } from "react";
import { Row, Col, Skeleton, Card, Button, message, Divider, Icon, Select, Checkbox } from "antd";
import UserActivitiesCard from "./parts/EA_And_LSP/UserActivityCard";
import Activity_card from "./parts/EA_And_LSP/ActivityCard";
import EaDashboardChart from "./parts/EA_And_LSP/EaDashboardCharts";
import EaProfileFilter from "./parts/EA_And_LSP/EaProfileFilter";
import axios from "axios";
import F from "../../Functions";
import moment from "moment";
import EaDateFilter from "./parts/EA_And_LSP/DateFilter";
import filter from "../../assets/icons/dashboard/filter.svg";
import { AGENCY_MANAGER, EA, SUPER_ADMIN } from "../../utils/Constants";
import CommonHeader from "./CommonHeader";
import BadPhoneNumber from "../../assets/phone-number.png";
import { COMBINED_COMPLETED_RAC_COUNT, GET_AM_ASSOCIATED_AGENCIES, GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE, GET_GLOBAL_DASH_BAD_PHONE_NUMBER_COUNT, GET_GLOBAL_DASH_ACTIVE_CALLS_COUNT, GET_GLOBAL_DASH_STATS, GET_GLOBAL_DASH_THREE_CARD_STATS, GET_GLOBAL_DASH_CUSTOMER_UPLOAD_LIVE_STATS, GET_GLOBAL_DASH_LIVE_APPOINTMENTS } from "../../utils/Api_enums";
import { Translate } from "react-translated";
import { useBoundStore } from '../../store/useBoundStore';
import './AMDashboard.css';

const Option = Select.Option;
const GLOBAL_DASH_STATS_START_DATE = "2010-01-01";
const GLOBAL_DASH_STATS_END_DATE = "2050-01-01";
const GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY = "globalDashboardInitialAgencyDateRange";
const DEFAULT_AGENCY_STATUS_FILTER = ["true"];

class AMDashboard extends Component {
    constructor(props) {
        super(props);
        // Default values

        const defaultPeriod = "from_to";
        let start_date = GLOBAL_DASH_STATS_START_DATE;
        let end_date = GLOBAL_DASH_STATS_END_DATE;
        let period = defaultPeriod;

        const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter;
        if (
            globalDashboardFilter.isDateRangeClicked &&
            globalDashboardFilter.datemodified.start_date &&
            globalDashboardFilter.datemodified.end_date
        ) {
            start_date = moment(globalDashboardFilter.datemodified.start_date).format("YYYY-MM-DD");
            end_date = moment(globalDashboardFilter.datemodified.end_date).format("YYYY-MM-DD");
        }

        this.state = {
            isAllBfiles: !globalDashboardFilter.isDateRangeClicked,
            selectedAgency: globalDashboardFilter.agency_id,
            collapsed: this.props.collapsed,
            loadingChart: true,
            loadingStats: true,
            loading: true,
            dashboard: {
                lsp: [],
                vo_stats: {
                    FollowUp: {},
                    Prospect: {},
                },
                stats: {},
                card_data: {},
            },
            period: period,
            start_date: start_date,
            end_date: end_date,
            associations: [],
            user: this.props.auth.user,
            user_type: this.props.auth.user.user_type,
            vonboard: 1,
            review: 1,
            colSpan: 8,
            is_lead: 1,
            is_opportunity: 1,
            show_lead_card_appointment_details: 1,
            user_t: localStorage.getItem('user_t') || "",
            filter_lsp: localStorage.getItem('filter_lsp') || "",
            internalFilterChange: false,
            has_rs: false,
            agency_id: null,
            agency: {},
            bfiles_counts: {
                leads: 0,
                opportunity: 0,
                review: 0,
            },
            badPhoneNumber: 0,
            agencies: [],
            selectedCarriers: globalDashboardFilter.selectedCarriers || [],
            selectedAgencyState: globalDashboardFilter.selectedAgencyState && globalDashboardFilter.selectedAgencyState.length
                ? globalDashboardFilter.selectedAgencyState
                : DEFAULT_AGENCY_STATUS_FILTER,
            selectedAgencies: globalDashboardFilter.selectedAgencies || [],
            filteredAgencies: [],
            filteredAgencyResults: [],
            allAgencies: []
        };
    }

    componentDidMount = () => {

        this.unsubscribe = useBoundStore.subscribe((state) => {
            this.setState({ selectedAgency: state.GlobalDashboardFilter.agency_id });
        });

        this.fetchAllAgenciesByCarrierAndActive();
    };


    componentWillUnmount() {
        this.unsubscribe();
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedAgency !== this.state.selectedAgency) {
            this.loadAdditionalData();
        }
    }



    //new picker impl
    fetchAssociatedAgencies = async () => {
        try {
            const res = await axios.get(`${GET_AM_ASSOCIATED_AGENCIES}/${this.state.user.id}`);

            if (res.data && res.data.length > 0) {
                const agencies = res.data;
                this.persistInitialAgencyDateRange(agencies);

                const store = useBoundStore.getState();
                const selectedAgencyId = store.GlobalDashboardFilter.agency_id;
                const defaultDateRange = this.getAgencyDateRange();
                const { start_date, end_date } =
                    this.getEffectiveGlobalDashboardDateRange(defaultDateRange);

                this.setState({
                    agencies,
                    start_date,
                    end_date,
                    selectedAgency: selectedAgencyId || null
                });

                useBoundStore.getState().setGlobalDashboardFilter({
                    datemodified: {
                        start_date: start_date || GLOBAL_DASH_STATS_START_DATE,
                        end_date: end_date || GLOBAL_DASH_STATS_END_DATE
                    },
                });

            } else {
                this.setState({
                    agencies: [],
                    start_date: GLOBAL_DASH_STATS_START_DATE,
                    end_date: GLOBAL_DASH_STATS_END_DATE
                });
            }

        } catch (error) {
            console.error("Error fetching associated agencies:", error);
        }
    };

    fetchAllAgenciesByCarrierAndActive = async (carrier = null, active = null) => {
        try {
            this.setState({ loading: true });

            const params = new URLSearchParams();

            const appendParam = (key, value) => {
                const values = Array.isArray(value) ? value : [value];

                values.forEach((item) => {
                    if (item !== null && item !== undefined && item !== "" && item !== "All Carrier") {
                        params.append(key, item);
                    }
                });
            };

            appendParam("carrier", carrier);
            appendParam("active", active);

            const queryString = params.toString();
            const res = await axios.get(`${GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE}${queryString ? `?${queryString}` : ""}`);

            if (res.data && res.data.length > 0) {
                const agencies = res.data;
                this.persistInitialAgencyDateRange(agencies);

                const store = useBoundStore.getState();
                const selectedAgencyId = store.GlobalDashboardFilter.agency_id;
                const validSelectedAgencies = (this.state.selectedAgencies || []).filter((agencyId) =>
                    agencies.some((agency) => agency.id === agencyId)
                );
                const filteredAgencies = this.getInitialFilteredAgencies(agencies, validSelectedAgencies);
                const agencyDateRange = this.getSelectedAgencyDateRange(validSelectedAgencies, agencies);
                const { start_date, end_date } = this.getEffectiveGlobalDashboardDateRange(agencyDateRange);

                await new Promise(resolve =>
                    this.setState({
                        agencies: agencies.slice(0, 100),
                        allAgencies: agencies,
                        filteredAgencies,
                        filteredAgencyResults: agencies,
                        selectedAgencies: validSelectedAgencies,
                        start_date,
                        end_date,
                        selectedAgency: selectedAgencyId || null
                    }, resolve)
                );

                useBoundStore.getState().setGlobalDashboardFilter({
                    selectedAgencies: validSelectedAgencies,
                    agency_id: validSelectedAgencies[0] || selectedAgencyId || '',
                    datemodified: {
                        start_date: start_date || GLOBAL_DASH_STATS_START_DATE,
                        end_date: end_date || GLOBAL_DASH_STATS_END_DATE
                    },
                });

                // Load stats after agencies are fetched
                await this.applyLocalAgencyFilters({
                    agencies,
                    selectedCarriers: this.state.selectedCarriers,
                    selectedAgencyState: this.state.selectedAgencyState,
                    selectedAgencies: validSelectedAgencies,
                });

            } else {
                this.setState({
                    agencies: [],
                    allAgencies: [],
                    filteredAgencies: [],
                    filteredAgencyResults: [],
                    badPhoneNumber: 0,
                    start_date: GLOBAL_DASH_STATS_START_DATE,
                    end_date: GLOBAL_DASH_STATS_END_DATE
                });
            }

        } catch (error) {
            console.error("Error fetching agencies by carrier and active status:", error);
            message.error("Failed to fetch agencies");
        } finally {
            this.setState({ loading: false });
        }
    };

    getSelectedCarrierParams = () => {
        return this.state.selectedCarriers.map((selectedCarrier) => {
            const carrier = F.getCarriers().find((item) => item.id === selectedCarrier);
            return carrier ? carrier.name : selectedCarrier;
        });
    };

    getGlobalDashboardCarriers = () => F.getCarriers().filter((carrier) => carrier.id !== "All Carrier");

    getAllCarrierIds = () => this.getGlobalDashboardCarriers().map((carrier) => carrier.id);

    getCarrierFilterValues = (selectedCarriers = this.state.selectedCarriers) => {
        return selectedCarriers
            .map((selectedCarrier) => {
                const carrier = F.getCarriers().find((item) => item.id === selectedCarrier);
                return carrier ? carrier.name : selectedCarrier;
            })
            .filter((carrier) => carrier && carrier !== "All Carrier");
    };

    getLocallyFilteredAgencies = (
        agencies = this.state.allAgencies,
        selectedCarriers = this.state.selectedCarriers,
        selectedAgencyState = this.state.selectedAgencyState
    ) => {
        const carrierFilters = this.getCarrierFilterValues(selectedCarriers);
        const activeFilters = selectedAgencyState.map(String);

        return agencies.filter((agency) => {
            const carrierMatch = carrierFilters.length === 0 || carrierFilters.includes(agency.agency_owner_carrier);
            const activeMatch = activeFilters.length === 0 || activeFilters.includes(String(agency.active === 1));

            return carrierMatch && activeMatch;
        });
    };

    applyLocalAgencyFilters = async ({
        selectedCarriers = this.state.selectedCarriers,
        selectedAgencyState = this.state.selectedAgencyState,
        selectedAgencies = this.state.selectedAgencies,
        agencies = this.state.allAgencies,
    } = {}) => {
        const filteredAgencyResults = this.getLocallyFilteredAgencies(agencies, selectedCarriers, selectedAgencyState);
        const validSelectedAgencies = (selectedAgencies || []).filter((agencyId) =>
            filteredAgencyResults.some((agency) => agency.id === agencyId)
        );
        const hasCarrierOrStateFilter = selectedCarriers.length > 0 || selectedAgencyState.length > 0;
        const filteredAgencyIds = hasCarrierOrStateFilter
            ? filteredAgencyResults.map((agency) => agency.id).filter(Boolean)
            : [];
        const filteredAgencies = this.getInitialFilteredAgencies(filteredAgencyResults, validSelectedAgencies);
        const agencyDateRange = this.getSelectedAgencyDateRange(validSelectedAgencies, filteredAgencyResults);
        const { start_date, end_date } = this.getEffectiveGlobalDashboardDateRange(agencyDateRange);

        await new Promise(resolve =>
            this.setState({
                filteredAgencyResults,
                filteredAgencies,
                selectedCarriers,
                selectedAgencyState,
                selectedAgencies: validSelectedAgencies,
                selectedAgency: validSelectedAgencies[0] || '',
                start_date,
                end_date,
                period: "from_to"
            }, resolve)
        );

        this.persistGlobalDashboardFilter({
            agency_id: validSelectedAgencies[0] || '',
            selectedCarriers,
            selectedAgencyState,
            selectedAgencies: validSelectedAgencies,
            filteredAgencyIds: hasCarrierOrStateFilter
                ? (filteredAgencyIds.length > 0 ? filteredAgencyIds : [-1])
                : [],
            datemodified: { start_date, end_date },
            isDateRangeClicked: useBoundStore.getState().GlobalDashboardFilter.isDateRangeClicked || false
        });
        localStorage.setItem("dateObj", JSON.stringify({ start_date, end_date, period: "from_to" }));

        useBoundStore.getState().setFsFilters({
            selectedAgency: validSelectedAgencies[0] || "",
            datemodified: { start_date, end_date }
        });

        await this.call_appointment_count();
        await this.loadCardData();
        await this.loadAMStats();
    };

    getGlobalDashboardAgencyIds = () => {
        const { selectedAgencies, selectedCarriers, selectedAgencyState, filteredAgencyResults } = this.state;
        const selectedAgency = useBoundStore.getState().GlobalDashboardFilter.agency_id;
        const hasCarrierOrStateFilter = selectedCarriers.length > 0 || selectedAgencyState.length > 0;

        if (selectedAgencies.length > 0) {
            return selectedAgencies;
        }

        if (selectedAgency && !hasCarrierOrStateFilter) {
            return [selectedAgency];
        }

        if (hasCarrierOrStateFilter) {
            const agencyIds = filteredAgencyResults.map((agency) => agency.id).filter(Boolean);
            return agencyIds.length > 0 ? agencyIds : [-1];
        }

        return [];
    };

    getGlobalDashboardBasePayload = () => {
        const currentDate = new Date();
        const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
        const hasSelectedAgency =
            Boolean(globalDashboardFilter.agency_id) ||
            (Array.isArray(globalDashboardFilter.selectedAgencies) &&
                globalDashboardFilter.selectedAgencies.length > 0);
        const payload = {
            agency_ids: this.getGlobalDashboardAgencyIds(),
            start_date: this.state.start_date,
            end_date: this.state.end_date
        };

        if (!globalDashboardFilter.isDateRangeClicked && !hasSelectedAgency) {
            payload.current_month = currentDate.getMonth() + 1;
            payload.current_year = currentDate.getFullYear();
        }

        return payload;
    };

    getAgencyDateRange = () => {
        return {
            start_date: GLOBAL_DASH_STATS_START_DATE,
            end_date: GLOBAL_DASH_STATS_END_DATE
        };
    };

    persistGlobalDashboardFilter = (filter) => {
        useBoundStore.getState().setGlobalDashboardFilter(filter);
    };

    getInitialFilteredAgencies = (agencies, selectedAgencies = this.state.selectedAgencies) => {
        const selectedIds = new Set(selectedAgencies);
        const selectedAgencyOptions = agencies.filter((agency) => selectedIds.has(agency.id));
        const firstAgencies = agencies.slice(0, 100);
        const optionMap = new Map();

        [...selectedAgencyOptions, ...firstAgencies].forEach((agency) => {
            optionMap.set(agency.id, agency);
        });

        return Array.from(optionMap.values());
    };

    getSelectedAgencyDateRange = () => this.getAgencyDateRange();

    persistInitialAgencyDateRange = () => {
        const initialAgencyDateRange = this.getAgencyDateRange();

        this.persistGlobalDashboardFilter({ initialAgencyDateRange });
        localStorage.setItem(
            GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY,
            JSON.stringify(initialAgencyDateRange)
        );

        return initialAgencyDateRange;
    };

    getEffectiveGlobalDashboardDateRange = (fallbackDateRange) => {
        const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
        const selectedDateRange = globalDashboardFilter.datemodified || {};

        if (
            globalDashboardFilter.isDateRangeClicked &&
            selectedDateRange.start_date &&
            selectedDateRange.end_date
        ) {
            return {
                start_date: moment(selectedDateRange.start_date).format("YYYY-MM-DD"),
                end_date: moment(selectedDateRange.end_date).format("YYYY-MM-DD")
            };
        }

        return fallbackDateRange;
    };



    fetchAgencyDetails = async (value) => {
        const zustandState = useBoundStore.getState().GlobalDashboardFilter;
        const selectedAgency = zustandState.agency_id;
        try {
            const res = await axios.get(`/api/agencies/${value}`);
            const activeCards = [
                res.data.review === 1,
                // res.data.is_lead === 1
                res.data.show_lead_card_appointment_details === 1,
                res.data.is_opportunity === 1,
            ].filter(Boolean).length;
            this.setState({
                vonboard: res.data.vonboard,
                review: res.data.review,
                active: res.data.active,
                is_lead: res.data.is_lead,
                is_opportunity: res.data.is_opportunity,
                show_lead_card_appointment_details: res.data.show_lead_card_appointment_details,
                agency: res.data,
                colSpan: activeCards > 0 ? Math.floor(24 / activeCards) : 24
            });
        } catch (error) {
            console.error("Error fetching agency details:", error);
        }
    };


    loadAdditionalData = async () => {
        try {
            // await this.call_appointment_count();
            // await this.loadCardData();
            // await this.loadAMStats();
        } catch (error) {
            console.error("Error loading additional data:", error);
        }
    };



    call_appointment_count = async () => {
        this.setState({ loadingChart: true });

        try {
            const payload = {
                agency_ids: this.getGlobalDashboardAgencyIds(),
                start_date: this.state.start_date,
                end_date: this.state.end_date
            };

            const [phoneNumberResponse] = await Promise.allSettled([
                axios.post(GET_GLOBAL_DASH_BAD_PHONE_NUMBER_COUNT, payload),
            ]);


            const bad_phone_number_count =
                phoneNumberResponse.status === "fulfilled"
                    ? phoneNumberResponse.value.data.count
                    : 0;

            // Update state with the fetched count
            this.setState({
                badPhoneNumber: bad_phone_number_count || 0,
            });
        } catch (error) {
            console.error("Error fetching appointment or phone number data:", error);
        } finally {
            this.setState({ loadingChart: false });
        }
    };

    resetAgencyFilter = () => {
        this.setState({ selectedAgency: "", selectedAgencies: [] });
        this.persistGlobalDashboardFilter({ agency_id: '', selectedAgencies: [] });
        useBoundStore.getState().setFsFilters({ selectedAgency: "" });
    }

    refreshStats = () => {
        useBoundStore.getState().setFsFilters({
            selectedAgency: "",
            datemodified: {
                start_date: undefined,
                end_date: undefined
            },
            isAllBfiles: true
        });

        this.persistGlobalDashboardFilter({
            agency_id: '',
            selectedCarriers: [],
            selectedAgencyState: DEFAULT_AGENCY_STATUS_FILTER,
            selectedAgencies: [],
            filteredAgencyIds: [],
            datemodified: {
                start_date: undefined,
                end_date: undefined
            },
            isDateRangeClicked: false
        });
        useBoundStore.getState().setAMDashboardFilter({
            datemodified: {
                start_date: undefined,
                end_date: undefined
            },
            isDateRangeClicked: false,
            isAllBfiles: true
        });

        localStorage.setItem('user_t', "");
        localStorage.setItem('filter_lsp', "");
        localStorage.removeItem("dateObj");
        localStorage.removeItem("dateObjRecentExtRaC");

        this.setState({
            selectedAgency: "",
            selectedCarriers: [],
            selectedAgencyState: DEFAULT_AGENCY_STATUS_FILTER,
            selectedAgencies: [],
            filteredAgencyIds: [],
            user_t: "",
            filter_lsp: "",
            isAllBfiles: true,
            period: "from_to"
        }, async () => {
            await this.fetchAllAgenciesByCarrierAndActive();
        });
    }



    refreshStatsAllBfile = () => {
        this.persistGlobalDashboardFilter({
            datemodified: {
                start_date: undefined,
                end_date: undefined
            },
            isDateRangeClicked: false
        });

        let obj = {
            start_date: GLOBAL_DASH_STATS_START_DATE,
            end_date: GLOBAL_DASH_STATS_END_DATE,
            period: "from_to"
        }

        localStorage.setItem('user_t', "");
        localStorage.setItem('filter_lsp', "");
        localStorage.setItem("dateObj", JSON.stringify(obj))
        this.setState({ user_t: "", filter_lsp: "", isAllBfiles: true, ...obj }, () => {
            setTimeout(async () => {
                await this.call_appointment_count();
                await this.loadCardData();
                await this.loadAMStats();
            }, 200);
        })
    }


    loadCardData = async (dateRangeSelected) => {
        this.setState({ loading: true });

        const basePayload = this.getGlobalDashboardBasePayload();
        const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
        const isDateRangeClicked = typeof dateRangeSelected === "boolean"
            ? dateRangeSelected
            : Boolean(globalDashboardFilter.isDateRangeClicked);
        const customerUploadPayload = {
            ...basePayload,
            monthly_count: !isDateRangeClicked
        };

        if (customerUploadPayload.monthly_count) {
            customerUploadPayload.current_month = new Date().getMonth() + 1;
            customerUploadPayload.current_year = new Date().getFullYear();
            delete customerUploadPayload.start_date;
            delete customerUploadPayload.end_date;
        }

        try {
            const [fourCardData, activeCalls, customerUploadMonthLiveCount] = await Promise.allSettled([
                axios.post(GET_GLOBAL_DASH_THREE_CARD_STATS, basePayload),
                axios.post(GET_GLOBAL_DASH_ACTIVE_CALLS_COUNT, basePayload),
                axios.post(GET_GLOBAL_DASH_CUSTOMER_UPLOAD_LIVE_STATS, customerUploadPayload)
            ]);

            const fourCardDataResult = fourCardData.status === 'fulfilled'
                ? fourCardData.value.data
                : {};

            const activeCallsResult = activeCalls.status === 'fulfilled'
                ? activeCalls.value.data
                : {};

            const customerUploadMonthLiveCountResult = customerUploadMonthLiveCount.status === 'fulfilled'
                ? customerUploadMonthLiveCount.value.data
                : {};



            const {
                customer_upload_history_literal = {},
                appointment_history_literal = {},
                not_interested_history_literal = {},
                non_responsive_history_literal = {},
            } = fourCardDataResult;

            const { active_calls_month = {}, active_calls_full = {} } = activeCallsResult;

            const live_monthly_CU_result = customerUploadMonthLiveCountResult;
            const customerUploadLiveLiteral = live_monthly_CU_result.customer_upload_live_literal || {};

            const categories = ["review", "lead", "opportunity"];
            const statsMap = {
                review: "Review",
                lead: "Prospect",
                opportunity: "FollowUp",
            };

            const card_data = categories.reduce((acc, category) => {
                const categoryKey = statsMap[category];
                const customerUploadLive = customerUploadLiveLiteral[categoryKey] || [];
                const customerUploadHistory = customer_upload_history_literal[categoryKey] || [];
                const appointmentHistory = appointment_history_literal[categoryKey] || [];
                const notInterestedHistory = not_interested_history_literal[categoryKey] || [];
                const nonResponsiveHistory = non_responsive_history_literal[categoryKey] || [];

                acc[category] = {
                    customer_upload_monthly: customerUploadLive[0] || 0,
                    customer_upload_total: isDateRangeClicked
                        ? customerUploadLive[0] || 0
                        : customerUploadHistory[0] || 0,
                    schedule_activity_monthly: appointmentHistory[1] || 0,
                    schedule_activity_total: appointmentHistory[0] || 0,
                    active_calls_monthly: active_calls_month[categoryKey] || 0,
                    active_calls_total: active_calls_full[categoryKey] || 0,
                    not_interested_monthly: notInterestedHistory[1] || 0,
                    not_interested_total: notInterestedHistory[0] || 0,
                    non_responsive_monthly: nonResponsiveHistory[1] || 0,
                    non_responsive_total: nonResponsiveHistory[0] || 0,
                };
                return acc;
            }, {});

            // Update state with the fetched data

            this.setState((prevState) => ({
                dashboard: {
                    ...prevState.dashboard,
                    card_data,
                },
            }));
        } catch (error) {
            // Improved error handling with detailed logging
            console.error("Error fetching dashboard card data:", error);
        } finally {
            // Set loading to false after completion
            this.setState({ loading: false });
        }
    };


    loadAMStats = async () => {
        const {
            period,
            start_date,
            end_date,
            dashboard,
        } = this.state;
        let data = { window: period };

        if (start_date != null && end_date != null) {
            data.from = start_date;
            data.to = end_date;
        }

        if (period != null && period != "from_to") {
            const datesData = F.getServerDateByType(period);
            data.from = datesData.from;
            data.to = datesData.to;
        }

        this.setState({
            loadingStats: true,
        });

        const agencyIds = this.getGlobalDashboardAgencyIds();
        const statsPayload = {
            start_date: GLOBAL_DASH_STATS_START_DATE,
            end_date: GLOBAL_DASH_STATS_END_DATE,
            agencies: agencyIds.length > 0 ? agencyIds : null
        };
        const liveAppointmentsPayload = {
            agency_ids: agencyIds,
            start_date: data.from || start_date,
            end_date: data.to || end_date
        };
        const combinedCountPayload = {
            from: GLOBAL_DASH_STATS_START_DATE,
            to: GLOBAL_DASH_STATS_END_DATE,
            agency_ids: agencyIds,
        };
        const combinedRacCount = axios.post(
            COMBINED_COMPLETED_RAC_COUNT,
            combinedCountPayload
        );



        try {
            const [statsApiData, calculatorResultData, combinedRacCountData] = await Promise.allSettled([
                axios.post(GET_GLOBAL_DASH_STATS, statsPayload),
                axios.post(GET_GLOBAL_DASH_LIVE_APPOINTMENTS, liveAppointmentsPayload),
                combinedRacCount,
            ]);

            const statsApiResult = statsApiData.status === 'fulfilled' ? statsApiData.value.data : {};
            const calculatorResultDataResult = calculatorResultData.status === 'fulfilled' ? calculatorResultData.value.data : {};
            const combinedRacCountResult = combinedRacCountData.status === 'fulfilled'
                ? F.get_combined_rac_count(combinedRacCountData.value)
                : 0;


            let agency_stats = statsApiResult.agency_stats || {};
            

            agency_stats = {
                ...agency_stats,
                completed: statsApiResult.completed_count_history || agency_stats.completed_count_history || agency_stats.completed,
                customer_upload: calculatorResultDataResult.upload_history_by_date_range || calculatorResultDataResult.customer_upload || agency_stats.customer_upload,
                combined_rac_files_count: combinedRacCountResult,
            };

            const updatedDashboard = {
                ...dashboard,
                stats: agency_stats,
            };

            this.setState((prevState) => ({
                ...prevState,
                dashboard: updatedDashboard,
            }));
        } catch (error) {
            console.error("Error fetching dashboard stats:", error);
        } finally {
            this.setState({ loadingStats: false }); // Set loading to false after completion
        }
    };

    getCurrentUserStats = (user_t, lsp) => {
        const userStats = lsp.find((item) => item.user && item.user.id === parseInt(user_t, 10));
        return userStats && userStats.stats ? userStats.stats : {};
    }

    refresh = async () => {
        await this.loadCardData();
        await this.loadAMStats();
        await this.call_appointment_count();
    };

    handleRoleChange = (newRole) => {

    }


    fetchAllBfiles = async () => {
        this.setState({ isAllBfiles: true }, async () => { // NOSONAR
            this.refreshStatsAllBfile(); // NOSONAR
        })
    };



    selectAgency = async (value) => {
        this.persistGlobalDashboardFilter({ agency_id: value || '' });
        const { start_date, end_date } = this.getEffectiveGlobalDashboardDateRange(
            this.getAgencyDateRange()
        );

        localStorage.setItem(
            'dateObjAgencySelectionAM',
            JSON.stringify({
                start_date: start_date,
                endDate: end_date
            })
        )

        this.setState({
            selectedAgency: value,
            start_date,
            end_date
        }, async () => {
            this.persistGlobalDashboardFilter({
                agency_id: value,
                datemodified: { start_date, end_date }
            });
            useBoundStore.getState().setFsFilters({
                selectedAgency: value,
                datemodified: { start_date, end_date }
            });

            await this.call_appointment_count();
            await this.loadCardData();

            await this.loadAMStats();
    
        });
    };



    selectAgencies = async (selectedAgencies) => {
        const primaryAgencyId = selectedAgencies[0] || null;
        const agencyDateRange = this.getSelectedAgencyDateRange(selectedAgencies, this.state.filteredAgencyResults);
        const { start_date, end_date } = this.getEffectiveGlobalDashboardDateRange(agencyDateRange);

        localStorage.setItem(
            'dateObjAgencySelectionAM',
            JSON.stringify({
                start_date,
                endDate: end_date
            })
        );
        localStorage.setItem("dateObj", JSON.stringify({ start_date, end_date, period: "from_to" }));

        this.setState({
            selectedAgencies,
            selectedAgency: primaryAgencyId,
            start_date,
            end_date
        }, async () => {
            this.persistGlobalDashboardFilter({
                agency_id: primaryAgencyId || '',
                selectedAgencies,
                datemodified: { start_date, end_date }
            });
            useBoundStore.getState().setFsFilters({
                selectedAgency: primaryAgencyId,
                datemodified: { start_date, end_date }
            });

            await this.call_appointment_count();
            await this.loadCardData();
            await this.loadAMStats();
        });
    };

    fetchFilteredAgencies = async () => {
        const { selectedCarriers, selectedAgencyState } = this.state;
        this.setState({ agencies: [], loading: true });

        try {
            const params = new URLSearchParams();

            if (selectedCarriers.length > 0) {
                selectedCarriers.forEach(c => params.append('carriers', c));
            }

            if (selectedAgencyState.length > 0) {
                selectedAgencyState.forEach(s => params.append('active', s));
            }

            const res = await axios.get(`/api/get_agency_by_agency_status_and_carrier?${params.toString()}`);
            this.setState({ filteredAgencies: res.data });
            if (res.data && res.data.length > 0) {
                const agencies = res.data;
                this.persistInitialAgencyDateRange(agencies);

                const store = useBoundStore.getState();
                const selectedAgencyId = store.GlobalDashboardFilter.agency_id;
                const validSelectedAgencies = (this.state.selectedAgencies || []).filter((agencyId) =>
                    agencies.some((agency) => agency.id === agencyId)
                );
                const filteredAgencies = this.getInitialFilteredAgencies(agencies, validSelectedAgencies);
                const agencyDateRange = this.getSelectedAgencyDateRange(validSelectedAgencies, agencies);
                const { start_date, end_date } = this.getEffectiveGlobalDashboardDateRange(agencyDateRange);

                await new Promise(resolve =>
                    this.setState({
                        filteredAgencies,
                        allAgencies: agencies,
                        selectedAgencies: validSelectedAgencies,
                        start_date,
                        end_date,
                        selectedAgency: selectedAgencyId || null
                    }, resolve)
                );
                useBoundStore.getState().setGlobalDashboardFilter({
                    selectedAgencies: validSelectedAgencies,
                    agency_id: validSelectedAgencies[0] || selectedAgencyId || '',
                    datemodified: {
                        start_date: start_date || GLOBAL_DASH_STATS_START_DATE,
                        end_date: end_date || GLOBAL_DASH_STATS_END_DATE
                    },
                });

                await this.call_appointment_count();
                await this.loadCardData();

                await this.loadAMStats();

            } else {
                await new Promise(resolve =>
                    this.setState({
                        agencies: [],
                        filteredAgencies: [],
                        allAgencies: [],
                        start_date: GLOBAL_DASH_STATS_START_DATE,
                        end_date: GLOBAL_DASH_STATS_END_DATE
                    }, resolve)
                );

                await this.call_appointment_count();   // ← fallback dates se call

                await this.loadAMStats();
            }


        } catch (error) {
            console.error("Error fetching filtered agencies:", error);
        } finally {
            this.setState({ loading: false });
        }
    };



    render() {
        const {
            dashboard,
            associations,
            loading,
            loadingChart,
            loadingStats,
            agencyStatsLoading,
            myStatsLoading,
            lspStatsLoading,
            start_date,
            end_date,
            period,
            filter_lsp,
            collapsed,
            user_t,
        } = this.state;

        const user = this.props.auth.user;
        let user_type = user.user_type;
        if (user.user_type === "EA") user_type = "Agency Owner";
        if (user.user_type === "LSP") user_type = "Agency Member";

        const isDashboardHasData =
            dashboard.hasOwnProperty("agency_stats") &&
            dashboard.hasOwnProperty("stats");

        let date_url = "";
        if (period === "from_to") {
            date_url = "?from_to";
        }

        const {
            customer_uploaded,
            completed,
            saved_for_later,
            follow_up,
            total_pnc,
            // life_opportunities,
            umbrella_recommended,
            retirement_uncovered,
            total_assets_uncovered,
            combined_rac_files_count
        } = F.get_ea_stats(dashboard.stats, filter_lsp, user_t);

        let data = {
            customer_uploaded,
            completed,
            saved_for_later,
            follow_up,
            total_pnc,
            // life_opportunities,
            life_opportunities: dashboard.stats.life_opportunities || 0,
            umbrella_recommended,
            retirement_uncovered,
            total_assets_uncovered,
            combined_rac_files_count
        };


        let customer_result = F.get_activity_card_data_agency_manager(data, "", "customer_result").sort((a, b) => a.orderIndex - b.orderIndex) || [];
        const selectedUser = associations.find(user => user.id === parseInt(user_t, 10));


        const handleBadPhoneNumber = () => {
            let datemodified = useBoundStore.getState().fSfilters.datemodified;
            const initialDateRange = {
                start_date: datemodified.start_date || "2010-01-01",
                end_date: datemodified.end_date || "2050-01-01",
            };
            useBoundStore.getState().setFsFilters({
                datemodified: initialDateRange,
                searchText: "",
                page: 1,
                filter_by_column_name: {}
            })
            this.props.history.push(`/newbfiles/bad-phone-numbers?all_bfiles`);
        }


      


        return (
            <div className="eaDashboard">

                {
                    (this.props.auth.user.user_type == AGENCY_MANAGER ||
                        this.props.auth.user.user_type == SUPER_ADMIN)
                    && (
                        <CommonHeader user={this.props.auth.user}
                            onRoleChange={this.handleRoleChange}
                            isHidden={this.props.auth.user.user_type == SUPER_ADMIN} />
                    )
                }




                {
                    this.props.auth.user.user_type == SUPER_ADMIN && (
                        <div>
                            <div className="amdashboard-header-flex">
                                <div className="amdashboard-header-btn-wrap">
                                    <Button
                                        shape="round"
                                        type="default"
                                        className="bad_phone_number_am"
                                        onClick={handleBadPhoneNumber}
                                    >
                                        <img
                                            id="callicon"
                                            src={BadPhoneNumber}
                                            alt="Bad Phone Number"
                                            width="16px"
                                        />
                                        <span className="text-11">Bad Phone Numbers</span>
                                        <span className="text-11">{this.state.badPhoneNumber}</span>
                                    </Button>
                                </div>
                            </div>

                            <div className="amdashboard-header-flex">
                                {/* Select Carrier */}
                                <div className="amdashboard-responsive-flex">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select Carrier"
                                        getPopupContainer={(trigger) => {
                                            return trigger.parentElement;
                                        }}
                                        maxTagCount={1}
                                        maxTagTextLength={16}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                                        style={{ minWidth: 230, fontSize: '12px', backgroundColor: 'white', borderRadius: '20px', width: '100%', marginTop: 10 }}
                                        allowClear
                                        filterOption={(input, option) =>    // ← add
                                            option.props.children
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        className='custom-select agency-select'
                                        value={this.state.selectedCarriers}
                                        onChange={(val) => {
                                            this.applyLocalAgencyFilters({
                                                selectedCarriers: val,
                                                selectedAgencies: [],
                                            });
                                        }}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div
                                                    style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #e8e8e8", fontWeight: 600 }}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={() => {
                                                        const allIds = F.getCarriers().map((c) => c.id);
                                                        const isAllSelected = this.state.selectedCarriers.length === allIds.length;
                                                        const selectedCarriers = isAllSelected ? [] : allIds;
                                                        this.setState({ selectedCarriers, selectedAgencies: [] }, async () => {
                                                            await this.applyLocalAgencyFilters({
                                                                selectedCarriers,
                                                                selectedAgencies: [],
                                                            });
                                                        });
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={this.state.selectedCarriers.length === F.getCarriers().length}
                                                        indeterminate={this.state.selectedCarriers.length > 0 && this.state.selectedCarriers.length < F.getCarriers().length}
                                                    >
                                                        Select All
                                                    </Checkbox>
                                                </div>
                                                {menu}
                                            </div>
                                        )}
                                    >
                                        {F.getCarriers().map((carrier) => (
                                            <Option key={carrier.id} value={carrier.id}>{carrier.name}</Option>
                                        ))}
                                    </Select>
                                </div>

                                {/* Select Agency State */}
                                <div className="amdashboard-responsive-flex">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select Status"
                                        getPopupContainer={(trigger) => {
                                            return trigger.parentElement;
                                        }}
                                        maxTagCount={1}
                                        maxTagTextLength={16}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                                        style={{ minWidth: 160, fontSize: '12px', marginTop: 10, backgroundColor: 'white', borderRadius: '20px', width: '100%' }}
                                        allowClear
                                        filterOption={(input, option) =>    // ← add
                                            option.props.children
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        className='custom-select agency-select'
                                        value={this.state.selectedAgencyState.map(String)}
                                        onChange={(val) => {
                                            this.applyLocalAgencyFilters({
                                                selectedAgencyState: val,
                                                selectedAgencies: [],
                                            });
                                        }}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div
                                                    style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #e8e8e8", fontWeight: 600 }}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={() => {
                                                        const allIds = F.getAgenciesState().map((a) => String(a.id));
                                                        const isAllSelected = this.state.selectedAgencyState.length === allIds.length;
                                                        const selectedAgencyState = isAllSelected ? [] : allIds;
                                                        this.setState({ selectedAgencyState, selectedAgencies: [] }, async () => {
                                                            await this.applyLocalAgencyFilters({
                                                                selectedAgencyState,
                                                                selectedAgencies: [],
                                                            });
                                                        });
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={this.state.selectedAgencyState.length === F.getAgenciesState().length}
                                                        indeterminate={this.state.selectedAgencyState.length > 0 && this.state.selectedAgencyState.length < F.getAgenciesState().length}
                                                    >
                                                        Select All
                                                    </Checkbox>
                                                </div>
                                                {menu}
                                            </div>
                                        )}
                                    >
                                        {F.getAgenciesState().map((agency) => (
                                            <Option key={String(agency.id)} value={String(agency.id)}>{agency.name}</Option>
                                        ))}
                                    </Select>
                                </div>

                                {/* Select Agency — FIXED */}
                                <div className="amdashboard-responsive-flex">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select Agency"
                                        getPopupContainer={(trigger) => {
                                            return trigger.parentElement;
                                        }}
                                        maxTagCount={1}
                                        maxTagTextLength={16}
                                        filterOption={false}
                                        onSearch={(val) => {
                                            const { filteredAgencyResults } = this.state;
                                            if (!val) {
                                                this.setState({ filteredAgencies: this.getInitialFilteredAgencies(filteredAgencyResults) });
                                                return;
                                            }
                                            const lower = val.toLowerCase();
                                            const filtered = filteredAgencyResults.filter(a =>
                                                (a.name || `Agency #${a.id}`)
                                                    .toLowerCase()
                                                    .includes(lower)
                                            );
                                            this.setState({ filteredAgencies: filtered });
                                        }}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                                        style={{ minWidth: 230, fontSize: '12px', marginTop: 10, backgroundColor: 'white', borderRadius: '20px', width: '100%' }}
                                        allowClear
                                        className='custom-select agency-select'
                                        value={this.state.selectedAgencies}
                                        onChange={(val) => {
                                            this.selectAgencies(val);
                                        }}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div
                                                    style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #e8e8e8", fontWeight: 600 }}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={() => {
                                                        const allIds = this.state.filteredAgencies.map((a) => a.id);
                                                        const isAllSelected = this.state.selectedAgencies.length === allIds.length;
                                                        this.selectAgencies(isAllSelected ? [] : allIds);
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={this.state.selectedAgencies.length === this.state.filteredAgencies.length && this.state.filteredAgencies.length > 0}
                                                        indeterminate={this.state.selectedAgencies.length > 0 && this.state.selectedAgencies.length < this.state.filteredAgencies.length}
                                                    >
                                                        Select All
                                                    </Checkbox>
                                                </div>
                                                {menu}
                                            </div>
                                        )}
                                    >
                                        {this.state.filteredAgencies.map((agency) => (
                                            <Option key={agency.id} value={agency.id}>
                                                {agency.name || `Agency #${agency.id}`}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>


                                <div className="amdashboard-responsive-flex">


                                    <div style={{
                                        width: window.innerWidth <= 768 ? '100%' : 'auto',
                                        marginTop: window.innerWidth <= 576 ? '0' : '-20px'
                                    }}>
                                        <EaDateFilter
                                            state={{ ...this.state }}
                                            loadStats={() => Promise.resolve()}
                                            loadCardData={() => this.loadCardData(true)}
                                            call_appointment_count={() => this.call_appointment_count()}
                                            refreshStats={() => this.refreshStats()}
                                            fetchAllBfiles={() => this.fetchAllBfiles()}
                                            setState={(e, cb) => this.setState(e, () => {
                                                if (e.start_date || e.end_date || e.isDateRangeClicked !== undefined) {
                                                    this.persistGlobalDashboardFilter({
                                                        datemodified: {
                                                            start_date: e.start_date || this.state.start_date,
                                                            end_date: e.end_date || this.state.end_date
                                                        },
                                                        isDateRangeClicked: e.isDateRangeClicked !== undefined ? e.isDateRangeClicked : true
                                                    });
                                                }
                                                cb && cb();
                                            })}
                                            showAllBfiles={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }






                {!loading ? (
                    <Row gutter={[8, 8]} style={{ marginTop: 15 }}>
                        {/* {this.state.review === 1 && ( */}
                        <Col md={8} span={24}>
                            <UserActivitiesCard
                                refresh={() => this.refresh()}
                                state={{ ...this.state, type_of_call: "Review" }}
                                buttonStyle={{ background: "#57aeff" }}
                                name="Customer Uploaded"
                                appointment_name="Review Appointments Scheduled"
                                activity_name={"Review"}
                                isGlobalDashboard
                                props={this.props}
                            />
                        </Col>
                        {/* )} */}

                        {/* {this.state.show_lead_card_appointment_details === 1 && ( */}
                        <Col md={8} span={24}>
                            <UserActivitiesCard
                                refresh={() => this.refresh()}
                                state={{ ...this.state, type_of_call: "Prospect" }}
                                buttonStyle={{ background: "#219d5c" }}
                                name="Customer Uploaded"
                                activity_name={"Leads"}
                                appointment_name="Lead Appointments Scheduled"
                                isGlobalDashboard
                                props={this.props}

                            />
                        </Col>
                        {/* )} */}


                        {/* {this.state.is_opportunity === 1 && ( */}
                        <Col md={8} span={24}>
                            <UserActivitiesCard
                                refresh={() => this.refresh()}
                                state={{ ...this.state, type_of_call: "FollowUp" }}
                                className={collapsed ? "card_collapsed" : ""}
                                buttonStyle={{ background: "#ffd427" }}
                                name="Customer Uploaded"
                                activity_name={"Opportunities"}
                                appointment_name="Opportunity Appointments Scheduled"
                                isGlobalDashboard
                                props={this.props}

                            />
                        </Col>
                        {/* )} */}
                    </Row>
                ) : (
                    <div
                        style={{
                            marginTop: 20,
                            background: "#FFF",
                            padding: 20,
                        }}
                    >
                        <Skeleton active />
                    </div>
                )}

                {!loadingStats ? (
                    <Card className="custom-card">
                        {/* <div>
                            <EaDateFilter
                                state={{ ...this.state }}
                                loadStats={() => this.loadAMStats()}
                                setState={(e, cb) => this.setState(e, () => cb && cb())}
                            />
                        </div> */}
                        <div className="calculator_result">
                            <div
                                className="activity_name"
                                style={{ position: "absolute", width: "95%", top: "15px" }}
                            >
                                Total Intelligence Link Results
                            </div>
                            {/* <Row gutter={8} className="activity_name_card" style={{ marginTop: 25 }}> */}
                            <div style={{
                                marginTop: 30,
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                            }}>
                                {[
                                    customer_result.slice(0, 1),
                                    customer_result.slice(1, 4),
                                    customer_result.slice(4),
                                ].map((cardRow, rowIndex) => (
                                    <div
                                        key={rowIndex}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "100%",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {cardRow.map((e, index) => (
                                            <Activity_card
                                                key={`${rowIndex}-${index}`}
                                                md={e.md}
                                                link={e.link}
                                                name={e.name}
                                                count={e.count}
                                                img={e.icon || ""}
                                                index={e.index}
                                                drillDownDateRange={{
                                                    start_date: GLOBAL_DASH_STATS_START_DATE,
                                                    end_date: GLOBAL_DASH_STATS_END_DATE
                                                }}
                                                props={this.props}
                                            />
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* <div className="calculator_result" style={{ paddingTop: 0 }}>
              <Row gutter={24} className="activity_name_card">
                {bfile_status.map((e, index) => {
                  return (
                    <Activity_card
                      key={index}
                      link={e.link}
                      img={e.icon || ""}
                      name={e.name}
                      count={e.count}
                      md={7}
                    />
                  );
                })}
              </Row>
            </div> */}
                    </Card>
                ) : (
                    <div
                        style={{
                            marginTop: 20,
                            background: "#FFF",
                            padding: 20,
                        }}
                    >
                        <Skeleton active />
                    </div>
                )}
            </div>
        );
    }
}

export default AMDashboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/GlobalDashboard.js